import i18n from '@/i18n/i18n';
import mensagem from '@/common/utils/mensagem';
import helpers from '@/common/utils/helpers';

const centavos = (valor) => Math.round(Number(valor || 0) * 100);

// O lançamento manual pode ser salvo com débito diferente de crédito (a escola confere e ajusta depois);
// o fechamento do período é que bloqueia enquanto houver diferença.
export default async (debitoTotal, creditoTotal) => {
  if (centavos(debitoTotal) === centavos(creditoTotal)) return true;

  const resposta = await mensagem.confirmacao(
    i18n.t('CONTABIL_LANCAMENTO.CONFIRMAR_DIFERENCA_DEBITO_CREDITO'),
    i18n.t('CONTABIL_LANCAMENTO.CONFIRMAR_DIFERENCA_DEBITO_CREDITO_MENSAGEM', {
      debito: helpers.formatacaoMoedaBRL(Number(debitoTotal || 0)),
      credito: helpers.formatacaoMoedaBRL(Number(creditoTotal || 0)),
    })
  );

  return !!resposta.value;
};
